import { AssetBucketUrlPrefix } from '../../../utils/Constants';

export const experienceText = {
  title: 'EXPERIENCE',
  index: 4,
  id: 'experience',
  contentItems: [
    {
      company: 'NVIDIA',
      title: 'SENIOR SOFTWARE ENGINEER',
      org: 'METROPOLIS',
      date: 'JAN 2026 - PRESENT',
      description:
        'Building the Public Safety blueprint to automate real-time video search and intelligent security alerting. https://docs.nvidia.com/vss/3.0.0/publicsafety-docs/3.0.0/index.html',
      imgSrc: ``,
      imgAlt:
        "TODO",
    },
    {
      company: 'SCALE AI',
      title: 'FULL-STACK SOFTWARE ENGINEER',
      org: 'GEN AI',
      date: 'JUL 2025 - JAN 2026',
      description:
        'Developed the GenAI platform for data labeling workflows that power model training for OpenAI, Google, and Meta.',
      imgSrc: ``,
      imgAlt:
        "TODO",
    },
    {
      company: 'AMAZON',
      title: 'SOFTWARE DEV ENGINEER II',
      org: 'PEOPLE ENGINE',
      date: 'NOV 2023 - JUL 2025',
      description:
        'Built a service to routinely check for missing employee personal information and notify up to 3 million employees to update their data.',
      imgSrc: `${AssetBucketUrlPrefix}/experience-assets/atozProfilePage.webp`,
      imgAlt:
        "Image of an Amazon employee's profile page showing a red banner at the top to indicate that they are missing personal information",
    },
    {
      company: 'AMAZON',
      title: 'SOFTWARE DEV ENGINEER II',
      org: 'AMAZON GAME STUDIOS',
      date: 'DEC 2021 - NOV 2023',
      description:
        'Part of the launch team for a new way of selling games on Amazon.com. The stack included a React / TypeScript frontend, and a GraphQL / Kotlin backend. Built the checkout system which handles purchasing and retrieving customer billing information.',
      imgSrc: `${AssetBucketUrlPrefix}/experience-assets/turboCheckoutError.webp`,
      imgAlt:
        'Image of a checkout modal to purchase a game with information such as ESRB rating, payment method, gift card balance, and a buy button.',
    },
    {
      company: 'AWS',
      title: 'SOFTWARE DEV ENGINEER I',
      org: 'AWS APP MESH',
      date: 'FEB 2021 - DEC 2021',
      description:
        'Engaged in on-call responsibilities, feature development, and contributed to regional infrastructure build-ups. Implemented a customer facing feature which allowed an Envoy proxy to intercept and manage DNS queries made by an application.',
      imgSrc: `${AssetBucketUrlPrefix}/experience-assets/appMesh.webp`,
      imgAlt: 'Image of the AWS App Mesh console.',
    },
  ],
};
